<template>
	<div class="q_pad_lr15px q_mar_t15px">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功"  v-if="!showEmpty">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          error-text="请求失败，点击重新加载"
      >
		<div class="q_vertical_left q_mar_b15px" style="width: 100%" v-for="item in list" @click="goToSpeeddea(item.id)">
			<div class="q_inlineblock q_po_re">
				<van-image class="q_speed_img" fit="cover" :src="convertImg(item.pic)" />
			</div>
			<div class="q_mar_l15px q_inlineblock" style="width: 100%;">
				<div class="q_text_l q_bold q_moit2">{{item.ittle}}</div>
				<div class="q_mar_t30px">
					<div class="q_inlineblock q_color_default q_bold q_text_m">{{item.money}}元</div>
					<div class="q_text_s q_color_gray q_mar_t3px q_flo_right">{{item.createTime}}</div>
				</div>
			</div>
		</div>
      </van-list>

    </van-pull-refresh>
    <!--空数据-->
    <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
      <img src="@/assets/image/none.png" style="width: 26vw;"/>
      <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
    </div>
	</div>
</template>

<script>
	import {listDonation} from "@/api/donation";
  import {myDonationList} from "@/api/userDonation";
  import {wxCloseShare} from "@/utils/jiutang";

  export default {
		name: 'Myspeed',
		props: {
			msg: String
		},
		data() {
			return {
        showEmpty: false,
        refreshing: false,
        loading: false,
        finished: false,
        list: [],
        pageParam: {
          pageNum: 0,
          pageSize: 5,
          userId:''
        },
      }
		},
    created() {
      wxCloseShare()
    },
    methods: {
      /**
       * 下拉刷新
       */
      onRefresh() {
        this.pageParam = {
          pageNum: 0,
          pageSize: 5,
        }
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true
        this.onLoad()
      },
      /**
       * 下滑加载更多
       */
      onLoad() {
        this.pageParam.pageNum++
        if (this.pageParam.pageNum == 1) {
          this.$modal.loading()
        }
        //查询募捐项目信息列表
        myDonationList(this.pageParam).then(res => {
          console.log('r2222es',res)
          if (res.total == 0) {
            this.showEmpty = true
          }
          //是否下拉刷新
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }

          for (let i = 0; i < res.rows.length; i++) {
            //处理创建时间
            res.rows[i].percentage =  ((res.rows[i].money/res.rows[i].sumMoney)*100).toFixed(2)
            this.list.push(res.rows[i]);
          }

          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.list.length >= res.total) {
            this.finished = true;
          }
        }).finally(() => {
          this.$modal.closeLoading()
        })
      },
			goToSpeeddea(id) {
				this.$router.push({
					path: '/home/Speeddea', query: {id: id}
				});
			},
		},
	}
</script>
<style scoped="scoped">
	.q_speed_img {
		width: 110px;
		height: 110px;
	}

	.q_speed_img>>>.van-image__img {
		border-radius: 5px;
	}
</style>
